import { config } from "../config.js";
import { get, post, getWithStatus, postWithStatus } from "../services/http.js";

export let getAccountBalance = async function (fetchHistory = true) {
  let url = `${config.apiUrl}/account/balance`;
  if (fetchHistory) {
    url = `${url}?history=true`;
  }
  let data = await get(url, true);
  return data;
};

export let addGiftCardToAccount = async function (id) {
  let body = JSON.stringify({ gift_card_id: id });
  return await post(`${config.apiUrl}/account/balance`, body);
};

export let checkBalance = async function (id) {
  return await get(`${config.apiUrl}/giftcard/${id}`, false);
};

export let listGiftables = async function (id) {
  let data = await get(`${config.apiUrl}/products?giftable=1`, false);
  let products = data.products;
  products = data.products
    ? data.products.map((p) => {
        p.title = p.title.replace("Monthly", "1 Month");
        p.title = p.title.replace("Yearly", "1 Year");
        return p;
      })
    : [];
  return products;
};

export let checkoutGift = async function (details) {
  let data = await post(`${config.apiUrl}/gift`, JSON.stringify(details));
  if (data.error) {
    return data;
  }
  return { id: data.stripe_session_id };
};

// every active gift card product, for the gift cards page
export let listGiftCards = async function () {
  let data = await get(
    `${config.apiUrl}/products?limit=100&page=0&product-type-id=6&active=1&in-stock-only=1`,
    false
  );
  if (data.error) {
    return data;
  }
  return data.products || [];
};

// Status-aware lookups for the redeem page: 404 means "no such code", 200 with
// an error means the code exists but a rule blocks it, anything else is a
// problem on our side.
export let lookupGiftCard = async function (code) {
  return await getWithStatus(`${config.apiUrl}/giftcard/${code}`, false);
};

export let redeemGift = async function (code, commit) {
  let res = await postWithStatus(
    `${config.apiUrl}/redeem`,
    JSON.stringify({ code, commit })
  );
  let data = res.data;

  if (res.status === 200 && !data.error && !commit && data.product) {
    let attr = (name) =>
      ((data.product.attributes || []).find((a) => a.name === name) || {})
        .value;
    data.shipments = attr("Max # of Shipments per Month");
    data.num_rentals = attr("Max # of Puzzles");
  }
  return res;
};
